import React, {useEffect} from 'react';
import {Button, Form, Input} from 'antd';
import {useNavigate} from "react-router-dom";
import {MAIN} from "../../common/constants";
import {LogIn} from "../../redux/authReducer";
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {isLoggedIn, setError} from "../../common/selectors";
import {Logo} from "../../components/content/logo";
import styles from './auth.module.sass';


// Тип для формы авторизации
type FieldType = {
    username?: string;
    password?: string;
    remember?: string;
};

export const Auth = () => {

    // Получаем статус авторизации пользователя
    const log = useAppSelector(isLoggedIn)
    // Получаем ошибку авторизации, если есть
    const error = useAppSelector(setError)

    // Хук для навигации между страницами
    const navigate = useNavigate()
    // Получаем JWT токен из localStorage
    const jwt = localStorage.getItem('jwt')
    // Получаем функцию dispatch для отправки экшенов
    const dispatch = useAppDispatch()


    // Эффект: если пользователь авторизован и нет ошибки, перенаправляем на главную страницу
    useEffect(() => {
        if (log&&!error) {
            navigate(MAIN)
        }
    }, [jwt, navigate, log])

    // Обработчик успешной отправки формы
    const onFinish = (values: any) => {
        dispatch(LogIn({username: values.username, password: values.password}))
    };

    // Обработчик ошибки отправки формы
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };


    // Отрисовка компонента авторизации
    return (
        <div className={styles.main}>

           {/* <div className={styles.logo}>
                <Logo/>
            </div>

            <div className={styles.divider}></div>*/}
            {/* Форма авторизации */}
            <div className={styles.form} >
                <div className={styles.item}>
                    <Form
                        name="basic"
                        labelCol={{span: 8}}
                        wrapperCol={{span: 16}}
                        style={{maxWidth: 600}}
                        initialValues={{remember: true}}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"

                    >
                        {/* Поле для логина */}
                        <Form.Item<FieldType>
                            label="Логин"
                            name="username"
                            rules={[{required: true, message: 'Введите свой логин!'}]}
                        >
                            <Input/>
                        </Form.Item>
                        {/* Поле для пароля */}
                        <Form.Item<FieldType>
                            label="Пароль"
                            name="password"
                            rules={[{required: true, message: 'Введите свой пароль!'}]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        {/* Кнопка входа */}
                        <Form.Item wrapperCol={{sm: {offset: 8, span: 16,}}}>
                            <Button type="primary" htmlType="submit" className={styles.button} >
                                Вход
                            </Button>
                        </Form.Item>
                        {/* Сообщение об ошибке авторизации */}
                        <Form.Item wrapperCol={{sm: {offset: 8, span: 16,}}} style={{opacity: error===401&&!log ? 1 : 0}}>
                            <div style={{color: 'red'}}>Неправильный логин или пароль</div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
};
